import React, {
  useCallback,
  useEffect,
  useState,
  useMemo, useRef
} from 'react';
import { Column } from 'devextreme-react/data-grid';
import { Button } from 'devextreme-react';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import CheckBox from 'devextreme/ui/check_box';
import { format } from 'date-fns';
import { formatMessage } from 'devextreme/localization';
import notify from 'devextreme/ui/notify';
import { isOne, trim } from '../../../utils/functions';
import PopupMVP from '../../PopupMVP';
import PopupErrorMVP from '../../PopupErrorMVP';
import DataGridMVP from '../../DataGridMVP';
import HeaderButtonMVP from '../../HeaderButtonMVP';

import columnDataAZH from './columnDataAZH';
import columnDataGraif from './columnDataGraif';
import columnDataGrid from './columnDataGrid';
import columnDataGridConsignment from './columnDataGridConsignment';
import columnDataHub from './columnDataHub';
import columnDataM15 from './columnDataM15';
import columnDataM4 from './columnDataM4';
import columnDataMKM from './columnDataMKM';
import columnDataMX1 from './columnDataMX1';
import columnDataMX3 from './columnDataMX3';
import columnDataNotGP from '../columnDataNotGP';
import columnDataProjectNum from '../columnDataProjectNum';
import columnDataTranspOrder from '../columnDataTranspOrder';
import columnDataSemiAttrb from '../columnDataSemiAttrb';
import columnDataTN from '../columnDataTN';
import columnDataClientArrival from '../columnDataClientArrival';

const Shipment = ({
  settingsReducer: { settings },
  shipmentReducer: {
    listShipment,
    loading,
    loadingData,
    okConsignment,
    okRequest,
    okUpdate,
    error,
    okList
  },
  tabsReducer: { tabSelect },
  userReducer: {
    permissions,
    id
  },
  isHub,
  isUseAZH,
  isUseCheckShiptoAddress,
  isUseFIFO,
  isUseM4,
  getProcessingStartCancel,
  getProcessingStartClear,
  getShipment,
  getShipmentActRemoveMh3,
  getShipmentErrorClear,
  modalAwaitingProcessingStartOpen,
  modalErrorOpen,
  modalShipmentAddReportOverdueOpen,
  modalShipmentClientArrivalDateOpen,
  modalShipmentCancelReasonConsignmentClose,
  modalShipmentCheckFIFOOpen,
  modalShipmentRedeemConsignmentOpen,
  modalShipmentSZRebindingOpen,
  modalSKZipOpen,
  plantId,
  showTranspOrder,
  setSelectedDocItems
}) => {
  /** фильтры из localStorage */
  const localTemp = JSON.parse(localStorage.getItem(`dataGridShipmentConsignment${plantId}`));

  /** Данные по таблице */
  const [thisDataGridInstance, setThisDataGridInstance] = useState({});
  /**
   * Переменная для определения текущего рендера списка,
   * где 0 = первый рендер или очистка фильтра
   */
  const isListMounted = useRef(0);

  /** Модальки / свойство */
  const [modalData, setModalData] = useState({
    visibleProcessing: false,
    visibleNotProcessing: false
  });

  /** Фильтры по таблице */
  const [filterDataGrid, setFilterDataGrid] = useState({
    dateFrom: '',
    dateTo: '',
    filter: localTemp ? localTemp.searchText : '',
    statusId: null
  });

  /** Сохранение фильтров для сравнения изменений перед запросом */
  const prevFilterDataGrid = useRef(filterDataGrid);

  /** Выборка элементов */
  const [selectItem, setSelectItem] = useState([]);
  // Выбранные элементы списка
  const [checked, setChecked] = useState([]);

  /** Сохранение выбранных элементов для передачи в запрос,
   * чтобы не реагировать на каждое изменение checked */
  const prevCheckedRef = useRef(checked);

  /** Стейт обновлены ли поля для изменения ширины */
  const [isFieldsUpdate, setIsFieldUpdate] = useState(false);

  useEffect(() => {
    if (tabSelect === 0) {
      isListMounted.current = 0;
    }
  }, [tabSelect]);

  // изменение переменной после получения списка
  useEffect(() => {
    if (okList) {
      isListMounted.current += 1;
    }
  }, [okList]);

  // Сохранение выбранных элементов текущей вкладки в хранилище
  useEffect(() => {
    if (tabSelect === 0) {
      window.localStorage.setItem('checkedItems', JSON.stringify(checked.map(({ pieceNumId, qcId, actualPieceId, cgId }) => ({ pieceNumId, qcId, actualPieceId, cgId }))));
    } else {
      window.localStorage.removeItem('checkedItems');
    }
  }, [checked, tabSelect]);

  /** Видимость поля при селекте строчек */
  const [headButtVisibol, setHeadButtVisibol] = useState({ display: 'none' });
  /** Выбор строк */
  const [dataSource, setDataSource] = useState({
    count: [0, 0, 0, 0, 0],
    listSubmerge: '',
    listNotSubmerge: '',
    listSubmergeItems: [],
    selectSubmergeItems: [],
    selectNotSubmergeItems: [],
    selectClientArrivalDateItems: {
      qcIds: [],
      pieceNumIds: []
    },
    listActRemoveMh3: [], /* Список УЕ где надо очистить акт мх3 */
    stringActRemoveMh3: '',
    stringActRemoveMh3Dop: '',
    selectRejectText: '',
    itemAcceptMh3: '',
    itemAcceptDate: '',
    skData: {
      count: 0,
      data: {}
    },
    selectProcessingItems: [],
    listProcessingItems: [],
    selectNotProcessingItems: [],
    listNotProcessing: ''
  });

  /** Видимость кнопок - Отгрузка, Отмена отгрузки */
  const [visibleBtn, setVisibleBtn] = useState({
    btnShipping: false,
    btnShippingCancel: false,
    btnRebinding: false
  });

  useEffect(() => {
    if (permissions.length) {
      setVisibleBtn({
        btnShipping: permissions.indexOf('btnShipping') !== -1,
        btnShippingCancel: permissions.indexOf('btnShippingCancel') !== -1,
        btnRebinding: settings.useSZRebinding
          && permissions.indexOf('prmChangeSO') !== -1
      });
    }
  }, [permissions, settings]);

  useEffect(() => () => {
    window.localStorage.removeItem('checkedItems');
  }, []);

  /** Всплывающие сообщения об ошибке */
  useEffect(() => {
    if (error) {
      modalErrorOpen({
        message: error.message || '',
        techInfo: error.techInfo || '',
        types: 'error'
      });
      getShipmentErrorClear();
    }
  }, [error, getShipmentErrorClear, modalErrorOpen]);

  /** Всплывающая подсказка */
  useEffect(() => {
    if (okRequest) {
      notify(
        {
          message: formatMessage('dataSuccess'),
          height: 64,
          width: 354,
          position: {
            at: 'top center',
            my: 'top center',
            offset: '0 48'
          }
        },
        'success',
        2000
      );
      thisDataGridInstance.instance.clearSelection();
      // setModalData({ visibleAccept: false, visibleReject: false });
      modalShipmentCancelReasonConsignmentClose();
    }
  }, [
    okRequest,
    thisDataGridInstance,
    modalShipmentCancelReasonConsignmentClose
  ]);

  useEffect(() => {
    prevCheckedRef.current = checked;
  }, [checked]);

  useEffect(() => {
    if (tabSelect !== 0 || id === null) return;

    const prevChecked = prevCheckedRef.current;

    if (okUpdate) {
      getShipment({
        ...filterDataGrid,
        plantId,
        items: prevChecked.map(({ pieceNumId }) => pieceNumId)
      });
      thisDataGridInstance.instance.clearSelection();

      return;
    }

    // после загрузки таблицы ссылка на объект фильтров меняется,
    // и получается, что предыдущие и текущие фильтры не равны
    const isFilterActive = Object.values(filterDataGrid).filter(Boolean).length;
    const filtersChanged = prevFilterDataGrid.current !== filterDataGrid;

    // если фильтры изменились
    if (filtersChanged) {
      getShipment({
        ...filterDataGrid,
        plantId,
        items: prevChecked.map(({ pieceNumId }) => pieceNumId)
      });

      return;
    }

    // если это первый рендер и фильтры пустые
    if (isListMounted.current === 0 && !isFilterActive) {
      getShipment({
        ...filterDataGrid,
        plantId,
        items: []
      });
    }

    isListMounted.current += 1;
    prevFilterDataGrid.current = filterDataGrid;
  }, [
    tabSelect,
    id,
    okUpdate,
    filterDataGrid,
    plantId,
    getShipment,
    thisDataGridInstance.instance
  ]);

  useEffect(() => {
    if (thisDataGridInstance.instance) {
      if (loadingData) {
        thisDataGridInstance.instance.beginCustomLoading('Loading...');
      } else {
        thisDataGridInstance.instance.endCustomLoading();
      }
    }
  }, [loadingData, thisDataGridInstance]);

  /** Функция закрытия модальки */
  const modalOnHiding = useCallback(() => {
    setModalData({
      visibleProcessing: false,
      visibleNotProcessing: false
    });
    // setIsValid(1);
    getProcessingStartClear();
  }, [
    getProcessingStartClear
  ]);

  /** Функция открытия модальки на выкуп или проверки на FIFO */
  const onClickButtonSubmerge = useCallback(() => {
    // setIsFocusItems({
    //   data: false,
    //   mh3: false
    // });
    // setModalData({
    //   ...modalData,
    //   visibleSubmerg: true
    // });
    if (dataSource.selectSubmergeItems.length === 1) {
      setDataSource({
        ...dataSource,
        itemAcceptMh3: dataSource.selectSubmergeItems[0].mh3,
        itemAcceptDate: format(new Date(), 'yyyy-MM-dd')
      });
    }
    if (dataSource.selectSubmergeItems.length > 1) {
      const tempData = dataSource.selectSubmergeItems[0];

      dataSource.selectSubmergeItems.forEach((item) => {
        if (tempData.mh3 !== item.mh3) {
          tempData.mh3 = '';
        }
      });

      setDataSource({
        ...dataSource,
        itemAcceptMh3: tempData.mh3,
        itemAcceptDate: format(new Date(), 'yyyy-MM-dd')
      });
    }
    if (
      isOne(
        dataSource.selectSubmergeItems,
        'plantId',
        Number(plantId)
      )
    ) {
      if (
        isOne(
          dataSource.selectSubmergeItems,
          'shiptoAddressSo',
          0
        ) || !isUseCheckShiptoAddress
      ) {
        if (isUseFIFO) {
          modalShipmentCheckFIFOOpen({
            plantId,
            selectItems: dataSource.selectSubmergeItems,
            selectList: dataSource.listSubmergeItems
          });
        } else {
          modalShipmentRedeemConsignmentOpen({
            plantId,
            selectSubmergeItems: dataSource.selectSubmergeItems,
            listSubmergeItems: dataSource.listSubmergeItems
          });
        }
      } else {
        modalErrorOpen({
          message: formatMessage('textError').differentShiptoAddressSo,
          techInfo: '',
          types: 'info',
          title: formatMessage('textError').warning
        });
      }
    } else {
      modalErrorOpen({
        message: formatMessage('textError').differentWarehousesSelected,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    }
  }, [
    dataSource,
    modalErrorOpen,
    modalShipmentRedeemConsignmentOpen,
    plantId,
    isUseFIFO,
    modalShipmentCheckFIFOOpen,
    isUseCheckShiptoAddress
  ]);

  /** Функция открытия модальки на отмену выкупа */
  // const onClickButtonNotSubmerge = useCallback(() => {
  //   setIsFocusItems({
  //     data: false,
  //     mh3: false
  //   });
  //   setModalData({
  //     ...modalData,
  //     visibleNotSubmerg: true
  //   });
  // }, [modalData]);

  /** Отмена переработки */
  const onClickButtonNotProcessing = useCallback(() => {
    if (
      isOne(
        selectItem.filter(
          (item) => dataSource.selectNotProcessingItems.indexOf(item.pieceNumId) >= 0
        ),
        'plantId',
        Number(plantId)
      )
    ) {
      setModalData({
        ...modalData,
        visibleNotProcessing: true
      });
    } else {
      modalErrorOpen({
        message: formatMessage('textError').differentWarehousesSelected,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    }
  }, [
    dataSource.selectNotProcessingItems,
    modalData,
    modalErrorOpen,
    plantId,
    selectItem
  ]);

  /** Функция открытия модальки на отложенную переработку */
  const onClickButtonProceessing = useCallback(() => {
    setModalData({
      ...modalData,
      visibleProcessing: true
    });
    if (
      isOne(
        dataSource.selectProcessingItems,
        'plantId',
        Number(plantId)
      )
    ) {
      modalAwaitingProcessingStartOpen({
        plantId,
        selectList: dataSource.selectProcessingItems
      });
    } else {
      modalErrorOpen({
        message: formatMessage('textError').differentWarehousesSelected,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    }
  }, [
    modalData,
    dataSource.selectProcessingItems,
    plantId,
    modalAwaitingProcessingStartOpen,
    modalErrorOpen
  ]);

  /** Отправка отмены переработки */
  const sendNotProcessing = useCallback(() => {
    getProcessingStartCancel({
      items: dataSource.selectNotProcessingItems,
      plantId
    });
    thisDataGridInstance.instance.clearSelection();
    modalOnHiding();
    // else {
    //   setIsValid(0);
    // }
    // eslint-disable-next-line
  }, [plantId, dataSource]);

  /** Функция открытия модальки на добавление УЕ в отчёт сверх нормативного хранения */
  const onClickButtonAddToReport = useCallback(() => (
    modalShipmentAddReportOverdueOpen({
      listItems: selectItem
    })
  ), [selectItem, modalShipmentAddReportOverdueOpen]);

  /** Событие на выделение строк */
  const dataGridOnSelection = useCallback((selectedRowsData, component, dataSourceDop) => {
    if (selectedRowsData.length) {
      setChecked(selectedRowsData);
      const temp = [0, 0, 0, 0, 0];
      let listSubmerge = '';
      let listNotSubmerge = '';
      const selectSubmergeItems = [];
      const listSubmergeItems = [];
      const selectNotSubmergeItems = [];
      const selectClientArrivalDateItems = {
        qcIds: [],
        pieceNumIds: []
      };
      const selectShippedItems = [];
      const rowsToDeselect = [];
      const listActRemoveMh3 = [];
      let stringActRemoveMh3 = '';
      let stringActRemoveMh3Dop = '';
      const arrayActRemoveMh3Dop = [];
      let prover = false;
      const skData = {
        count: 0,
        data: {}
      };
      const selectProcessingItems = [];
      const listProcessingItems = [];
      const selectNotProcessingItems = [];
      let listNotProcessing = '';
      selectedRowsData.forEach((item) => {
        skData.count += 1;
        skData.data[item.qcId] = {
          qcNumId: item.qcNumId,
          qcShop: item.qcShopCode,
          qcDate: item.accountingDate
        };

        if (item.onHoldFlag) {
          rowsToDeselect.push(item.pieceNumId);
          modalErrorOpen({
            message: `${formatMessage('textModal').textIncomingHoldLeft} 
            ${item.qcId} ${formatMessage('textModal').textIncomingHoldRight}`,
            techInfo: '',
            types: 'info',
            title: formatMessage('textError').warning
          });
        } else {
          // eslint-disable-next-line no-lonely-if
          if (item.psStatusName === 'В наличии') {
            temp[0] += 1;
            listSubmerge += `${item.cgId} ${item.actualPieceId}; `;
            selectSubmergeItems.push(item);
            listSubmergeItems.push(item.pieceNumId);
            prover = true;
            /* Проверка на наличие акта */
            if (item.mh3 && item.mh3 !== '') {
              listActRemoveMh3.push(item.pieceNumId);
              stringActRemoveMh3 += `${item.cgId} ${item.actualPieceId}; `;
              if (arrayActRemoveMh3Dop.indexOf(`${item.mh3})`) === -1) {
                stringActRemoveMh3Dop += `${item.mh3} ${format(new Date(item.mh3Date), 'dd.MM.yyyy')}; `;
                arrayActRemoveMh3Dop.push(`${item.mh3})`);
              }
            }
            temp[2] += 1;
            selectProcessingItems.push(item);
            listProcessingItems.push(item.pieceNumId);
            if (item.dateProcessingStart) {
              temp[3] += 1;
              listNotProcessing += `${item.heatId}-${item.cgId}-${item.actualPieceId}; `;
              selectNotProcessingItems.push(item.pieceNumId);
            }
          } else if (item.psStatusName === 'Отгружен') {
            temp[4] += 1;
            selectShippedItems.push(item);
            selectClientArrivalDateItems.pieceNumIds.push(item.pieceNumId);
            selectClientArrivalDateItems.qcIds.push(item.qcId);
            prover = true;
          } else if (item.psStatusName === 'Выкуплен') {
            temp[1] += 1;
            listNotSubmerge += `${item.cgId} ${item.actualPieceId}; `;
            selectNotSubmergeItems.push(item.pieceNumId);
            prover = true;
          } else if (item.psStatusName === 'В пути') {
            rowsToDeselect.push(item.pieceNumId);
          }
        }
      });
      if (rowsToDeselect.length) {
        component.deselectRows(rowsToDeselect);
      }
      setDataSource({
        ...dataSourceDop,
        count: temp,
        listSubmerge,
        listNotSubmerge,
        listSubmergeItems,
        selectSubmergeItems,
        selectNotSubmergeItems,
        selectClientArrivalDateItems,
        listActRemoveMh3,
        stringActRemoveMh3,
        stringActRemoveMh3Dop,
        skData,
        selectProcessingItems,
        listProcessingItems,
        selectNotProcessingItems,
        listNotProcessing
      });
      if (prover) {
        setHeadButtVisibol({ display: 'flex' });
        setSelectItem([...selectSubmergeItems, ...selectShippedItems]);
      }
    } else {
      window.localStorage.removeItem('checkedItems');
      setDataSource({
        ...dataSourceDop,
        count: [0, 0, 0, 0, 0],
        skData: {
          count: 0,
          data: {}
        }
      });
      setHeadButtVisibol({ display: 'none' });
      setChecked([]);
    }
  }, [modalErrorOpen]);

  /** Функция на обработку чекбоксов неактивными */
  const onCellPrepared = useCallback((e) => {
    if (e.rowType === 'data' && e.column.command === 'select' && e.data.psStatusName === 'В пути') {
      const instatnce = CheckBox.getInstance(e.cellElement.querySelector('.dx-select-checkbox'));
      instatnce.option('disabled', true);
      e.cellElement.style.pointerEvents = 'none';
    }
  }, []);

  /** Поисковая строка */
  const dataGridOnOptionChanged = useCallback(({ value, name }) => {
    if (name === 'searchPanel') {
      if (!value) {
        isListMounted.current = 0;
      }
      setFilterDataGrid({ ...filterDataGrid, filter: value });
    }
  }, [filterDataGrid]);

  /** Событие на закрыть */
  const closeHeaderButtom = useCallback(() => {
    thisDataGridInstance.instance.clearSelection();
    setHeadButtVisibol({ display: 'none' });
    setChecked([]);
  }, [thisDataGridInstance.instance]);

  /** Удаление УЕ из акта мх3 */
  const [visibleModalErrorActRemoveMh3, setVisibleModalErrorActRemoveMh3] = useState(false);
  const onClickButtonActRemoveMh3 = useCallback(() => {
    if (
      isOne(
        dataSource.selectSubmergeItems,
        'plantId',
        Number(plantId)
      )
    ) {
      setVisibleModalErrorActRemoveMh3(true);
    } else {
      modalErrorOpen({
        message: formatMessage('textError').differentWarehousesSelected,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    }
  }, [
    dataSource.selectSubmergeItems,
    modalErrorOpen,
    plantId
  ]);
  const onHidingModalErrorActRemoveMh3 = useCallback(() => {
    setVisibleModalErrorActRemoveMh3(false);
  }, []);
  const onModalErrorOnClickButtonYesActRemoveMh3 = useCallback(() => {
    getShipmentActRemoveMh3({ items: dataSource.listActRemoveMh3, plantId });
    setVisibleModalErrorActRemoveMh3(false);
  }, [dataSource.listActRemoveMh3, getShipmentActRemoveMh3, plantId]);

  // Групповое скачивание СК
  const onClickButtonSK = useCallback(() => {
    modalSKZipOpen({
      data: dataSource.skData.data,
      plantId
    });
  }, [
    dataSource.skData.data,
    modalSKZipOpen,
    plantId
  ]);

  // Обновление данных
  const onClickUpdate = useCallback(() => {
    const isFilterActive = Object.values(filterDataGrid).filter(Boolean).length;
    getShipment({
      ...filterDataGrid,
      plantId,
      items: isFilterActive ? checked.map(({ pieceNumId }) => pieceNumId) : []
    });
  }, [filterDataGrid, getShipment, plantId, checked]);

  // Обновление данных после выкупа
  useEffect(() => {
    if (okConsignment) {
      onClickUpdate();
    }
  }, [onClickUpdate, okConsignment]);

  /** Изменение ширины полей TODO придумать что-нибудь лаконичнее */
  useEffect(() => {
    if (listShipment.length && localTemp && !isFieldsUpdate) {
      let fieldModify = false;
      let dataFieldsName = ['qcId', 'documentId', 'mh3'];
      dataFieldsName.forEach((fieldName) => {
        let controlField = {
          name: fieldName,
          maxLength: 0,
          index: 0
        };
        if (!localTemp.columns.filter((item) => item.dataField === fieldName)[0]?.width) {
          localTemp.columns.forEach((item, index) => item.dataField === fieldName ? controlField.index = index : null);
          listShipment.forEach((item) => item[fieldName]?.length * 12 > controlField.maxLength ? controlField.maxLength = item[fieldName].length * 12 : null);
          if (controlField.maxLength !== 0) {
            localTemp.columns[controlField.index].width = controlField.maxLength;
            fieldModify = true;
          }
        }
      });
      if (fieldModify) {
        localStorage.setItem(`dataGridShipmentConsignment${plantId}`, JSON.stringify(localTemp));
        setIsFieldUpdate(true);
        onClickUpdate();
      }
    }
  }, [localTemp, listShipment, isFieldsUpdate, plantId, onClickUpdate]);

  useEffect(() => {
    setSelectedDocItems(selectItem);
  }, [setSelectedDocItems, selectItem]);

  /** открытие модального окна "Перепривязка СЗ" */
  const onClickSZRebinding = useCallback(() => {
    modalShipmentSZRebindingOpen({
      plantId,
      selectList: dataSource.selectSubmergeItems,
      filter: filterDataGrid
    });
  }, [dataSource.selectSubmergeItems, modalShipmentSZRebindingOpen, plantId, filterDataGrid]);

  const onClickClientArrivalDate = useCallback(() => {
    modalShipmentClientArrivalDateOpen({
      pieceNumIds: dataSource.selectClientArrivalDateItems.pieceNumIds,
      qcIds: dataSource.selectClientArrivalDateItems.qcIds,
      plantId,
      filterDataGrid
    })
  }, [
    dataSource.selectClientArrivalDateItems,
    modalShipmentClientArrivalDateOpen,
    plantId,
    filterDataGrid
  ]);

  const renderColumnAZH = useMemo(() => (
    columnDataAZH.map(
      (item) => (
        <Column
          dataField={item.dataField}
          caption={formatMessage('textTable').azh[item.dataField]}
          visible={!item.notVisible}
          allowSearch={false}
          allowFiltering
          cellRender={item.cellRender}
          key={item.dataField}
          dataType={item.dataType}
          cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnsDataGrid = useMemo(() => (
    columnDataGrid.map(
      (item) => {
        if (item.dataField === 'widthFact' && !settings.useMC) {
          return null;
        }

        return (
          <Column
            dataField={item.dataField}
            caption={plantId === 8226 ? formatMessage('textTable')[item.dataField] : formatMessage('textTable').consignment[item.dataField]}
            visible={!item.notVisible}
            allowSearch={false}
            allowFiltering
            cellRender={item.cellRender}
            key={item.dataField}
            dataType={item.dataType}
            cssClass={item.cssClass}
          />
        );
      }
    )
  ), [plantId, settings.useMC]);

  const renderColumnDataGridConsignment = useMemo(() => (
    columnDataGridConsignment.map(
      (item) => (
        <Column
          dataField={item.dataField}
          caption={formatMessage('textTable').consignment[item.dataField]}
          visible={!item.notVisible}
          allowSearch={false}
          allowFiltering
          cellRender={item.cellRender}
          key={item.dataField}
          dataType={item.dataType}
          cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnDataHub = useMemo(() => (
    columnDataHub.map(
      (item) => (
        <Column
          dataField={item.dataField}
          caption={formatMessage('textTable').consignment[item.dataField]}
          visible={!item.notVisible}
          allowSearch={false}
          allowFiltering
          key={item.dataField}
          dataType={item.dataType}
        />
      )
    )
  ), []);
  const renderColumnM15 = useMemo(() => (
    columnDataM15.map(
      (item) => (
        <Column
          dataField={item.dataField}
          caption={formatMessage('textTable').consignment[item.dataField]}
          visible={!item.notVisible}
          allowSearch={false}
          allowFiltering
          cellRender={item.cellRender}
          key={item.dataField}
          dataType={item.dataType}
          cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnM4 = useMemo(() => (
    columnDataM4.map(
      (item) => {
        if (item.dataField === 'widthFact' && !settings.useMC) {
          return null;
        }

        return (
          <Column
          dataField={item.dataField}
          caption={formatMessage('textTable').consignment[item.dataField]}
          visible={!item.notVisible}
          allowSearch={false}
          allowFiltering
          cellRender={item.cellRender}
          key={item.dataField}
          dataType={item.dataType}
          cssClass={item.cssClass}
        />
        );
      }
    )
  ), [settings.useMC]);

  const renderColumnMX1M4 = useMemo(() => (
    columnDataMX1.map(
      (item) => (
        <Column
          dataField={item.dataField}
          caption={formatMessage('textTable').MX1M4[item.dataField]}
          visible={!item.notVisible}
          allowSearch={false}
          allowFiltering
          cellRender={item.cellRender}
          key={item.dataField}
          dataType={item.dataType}
          cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnGraif = useMemo(() => (
    columnDataGraif.map(
      (item) => (
        <Column
          dataField={item.dataField}
          caption={formatMessage('textTable').consignment[item.dataField]}
          visible={!item.notVisible}
          allowSearch={false}
          allowFiltering
          cellRender={item.cellRender}
          key={item.dataField}
          dataType={item.dataType}
          cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnMX3 = useMemo(() => (
    columnDataMX3.map(
      (item) => (
        <Column
          dataField={item.dataField}
          caption={formatMessage('textTable').consignment[item.dataField]}
          visible={!item.notVisible}
          allowSearch={false}
          allowFiltering
          cellRender={item.cellRender}
          key={item.dataField}
          dataType={item.dataType}
          cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnMKM = useMemo(() => (
    columnDataMKM.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').consignment[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnProjectNum = useMemo(() => (
    columnDataProjectNum.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable')[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
        />
      )
    )
  ), []);

  const renderColumnDataNotGP = useMemo(() => (
    columnDataNotGP.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').consignment[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dateType={item.dateType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
        />
      )
    )
  ), []);

  const renderColumnTranspOrder = useMemo(() => (
    columnDataTranspOrder.map(
      (item) => (
        <Column
          dataField={item.dataField}
          caption={formatMessage('textTable')[item.dataField]}
          visible={!item.notVisible}
          allowSearch={false}
          allowFiltering
          cellRender={item.cellRender}
          key={item.dataField}
          dataType={item.dataType}
          cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnSemiAttrb = useMemo(() => (
    columnDataSemiAttrb.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable')[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
        />
      )
    )
  ), []);

  const renderColumnTN = useMemo(() => (
    columnDataTN.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable')[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.dataField === 'ttn' ? settings.useTtnCreate ? item.cellRender : '' : item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), [settings.useTtnCreate]);

  const renderColumnClientArrival = useMemo(() => (
    columnDataClientArrival.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable')[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const isGraif = useMemo(() => plantId === '6606' || plantId === '6607'
      || plantId === '7238' || plantId === '7257' || plantId === '7258'
      || plantId === '7259' || plantId === '7260' || plantId === '7261'
      || plantId === '10003' || plantId === '10004' || plantId === '10005', [plantId]);

  const isMKM = useMemo(() => plantId === '8103' || plantId === '8124'
      || plantId === '8125' || plantId === '8126' || plantId === '8127'
      || plantId === '8138' || plantId === '8139' || plantId === '8140', [plantId]);

  const isDipos = useMemo(() => plantId === '8141' || plantId === '8109', [plantId]);

  const renderDataGrid = useMemo(() => (
    <DataGridMVP
      dataSource={listShipment}
      setDataGridInstance={setThisDataGridInstance}
      onSelectionChanged={({ selectedRowsData, component }) => dataGridOnSelection(
        selectedRowsData,
        component,
        dataSource
      )}
      filterDataGrid={filterDataGrid}
      setFilterDataGrid={setFilterDataGrid}
      className="shipment"
      setStateStoringName={`dataGridShipmentConsignment${plantId}`}
      onCellPrepared={onCellPrepared}
      dataGridOnOptionChanged={dataGridOnOptionChanged}
      tText={formatMessage('textRedemptionPeriod')}
      loadingData={loadingData}
      onClickUpdate={onClickUpdate}
      visibleButtonUpdate
      // visibleButtonSelectFields
      shrinkToolbar={headButtVisibol.display !== 'none'}
    >
      { settings.useM4 ? renderColumnM4 : renderColumnsDataGrid }
      { settings.useM4 ? renderColumnMX1M4 : renderColumnDataGridConsignment }
      { isUseAZH ? renderColumnAZH : renderColumnMX3 }
      { !settings.useM4 && plantId === '7399' ? renderColumnM15 : null }
      { isGraif ? renderColumnGraif : null }
      { isMKM || isDipos ? renderColumnMKM : null }
      { showTranspOrder ? renderColumnTranspOrder : null }
      { settings.stockType ? renderColumnProjectNum : null }
      { settings.stockType !== 'ready' ? renderColumnDataNotGP : null }
      { isHub ? renderColumnDataHub : null}
      { settings.showSemiAttrb ? renderColumnSemiAttrb : null }
      { settings.useClientArrivalDate ? renderColumnClientArrival : null }
      { (settings.useTtnCreate || settings.useBuyoutWithTtn) ? renderColumnTN : null}

      <Column
        dataField={'productPlanDistr'}
        caption={formatMessage('textTable').recycling.productPlanDistr}
        allowSearch={false}
        allowFiltering
        dataType={'string'}
      />

      <Column
        dataField={'actualStorageTimeCount'}
        caption={formatMessage('textTable').consignment.actualStorageTimeCount}
        allowSearch={false}
        allowFiltering
        dataType={'string'}
      />

      <Column
        dataField={'pieceId'}
        caption={formatMessage('textTable').pieceId}
        allowSearch={false}
        allowFiltering
        dataType={'string'}
      />

      { settings.useTtnCreate
        && (
          <Column dataField={'ttnDocStatusDescr'}
                  caption={formatMessage('textTable').ttnDocStatusDescr}
                  allowSearch={false}
                  allowFiltering
                  dataType={'string'}
          />
        )}

      <Column
            dataField={'endCustomerName'}
            caption={formatMessage('textTable').endCustomerName}
            allowSearch={false}
            allowFiltering
            dataType={'string'}
            cellRender={({ data }) => {
              return data.endCustomerName || data.customerName || '';
            }}
      />

    </DataGridMVP>
  ), [
    dataGridOnOptionChanged,
    dataGridOnSelection,
    dataSource,
    filterDataGrid,
    listShipment,
    loadingData,
    onCellPrepared,
    plantId,
    renderColumnDataGridConsignment,
    renderColumnsDataGrid,
    renderColumnM15,
    renderColumnM4,
    renderColumnGraif,
    renderColumnDataHub,
    renderColumnMX1M4,
    renderColumnAZH,
    renderColumnMX3,
    renderColumnTranspOrder,
    renderColumnMKM,
    onClickUpdate,
    isGraif,
    isHub,
    isUseAZH,
    showTranspOrder,
    isMKM,
    isDipos,
    settings,
    renderColumnProjectNum,
    renderColumnDataNotGP,
    headButtVisibol.display,
    renderColumnSemiAttrb,
    renderColumnTN,
    renderColumnClientArrival
  ]);

  return (
    <>
      <HeaderButtonMVP headButtVisibol={headButtVisibol}>
        <Button icon="close" stylingMode="text" onClick={closeHeaderButtom} />
        <span className="span-first">{`${formatMessage('textDataGrid').selectQU}:`}</span>
        {(dataSource.count[0])
        && (
          <>
            <span>{`“В наличии” - ${dataSource.count[0]} `}</span>
            {(visibleBtn.btnShipping)
              ? (
                <Button text={isHub ? formatMessage('textButton').toShip : formatMessage('textButton').buyOut}
                        type="default"
                        stylingMode="contained"
                        onClick={onClickButtonSubmerge}
                />
              ) : ''}
            {(visibleBtn.btnShipping && dataSource.listActRemoveMh3.length > 0)
              ? (
                <Button text={formatMessage('textButton').removeFromAct}
                        type="default"
                        stylingMode="contained"
                        onClick={onClickButtonActRemoveMh3}
                />
              ) : ''}
          </>
        )}
        {dataSource.count[0] || dataSource.count[4] ? (
          <>
            <Button text={formatMessage('textButton').addToReportOverStorageDates}
                    type="default"
                    stylingMode="contained"
                    onClick={onClickButtonAddToReport}
            />
          </>
        ) : (
          <div />
        )}
        {(visibleBtn.btnShipping &&
          settings.useClientArrivalDate &&
          dataSource.selectClientArrivalDateItems.pieceNumIds.length ?
            <Button text={formatMessage('textArrivalDate')}
                    type="default"
                    stylingMode="contained"
                    onClick={onClickClientArrivalDate}
            /> : null
        )}
        {(dataSource.count[1])
          ? (<span>{`“Выкуплен” - ${dataSource.count[1]} `}</span>) : ''}
        {(dataSource.count[2])
        ? (
          <>
            {(visibleBtn.btnShipping && isGraif)
              ? (
                <span>{`“К переработке” - ${dataSource.count[2]} `}</span>
              ) : ''}
            {(visibleBtn.btnShipping && isGraif)
              ? (
                <Button text={formatMessage('textButton').processing}
                        type="default"
                        stylingMode="contained"
                        onClick={onClickButtonProceessing}
                />
              ) : ''}
          </>
        ) : ''}
        {(dataSource.count[3])
          ? (
            <>
              {(visibleBtn.btnShippingCancel && isGraif)
                ? (
                  <span>{`“В переработке” - ${dataSource.count[3]} `}</span>
                ) : ''}
              {(visibleBtn.btnShippingCancel && isGraif)
                ? (
                  <Button text={formatMessage('textButton').cancelProcessing}
                          type="default"
                          stylingMode="contained"
                          onClick={onClickButtonNotProcessing}
                  />
                ) : ''}
            </>
          ) : ''}
        {(dataSource.skData.count
          && (
            <>
              <Button text={formatMessage('textButton').downloadQc}
                      type="default"
                      stylingMode="contained"
                      onClick={onClickButtonSK}
              />
            </>
          ))}
        {(visibleBtn.btnRebinding && (
          <Button text={formatMessage('textButton').rebinding}
                  type="default"
                  stylingMode="contained"
                  onClick={onClickSZRebinding}
          />
        ))}
      </HeaderButtonMVP>
      { renderDataGrid }
      {/* Модальное окно на подтверждение удаления УЕ из акта мх3 */}
      <PopupErrorMVP
        visible={visibleModalErrorActRemoveMh3}
        message={`${formatMessage('textModal').deletePiece}: 
        ${trim(trim(dataSource.stringActRemoveMh3, ' '), ';')} 
        ${formatMessage('textModal').fromAct}: 
        ${trim(trim(dataSource.stringActRemoveMh3Dop, ' '), ';')} 
        ${formatMessage('textModal').respectively}?`}
        techInfo=""
        width={600}
        types="info"
        onHiding={onHidingModalErrorActRemoveMh3}
      >
        <div className="formButton">
          <Button text={formatMessage('textButton').no}
                  type="default"
                  stylingMode="text"
                  onClick={onHidingModalErrorActRemoveMh3}
          />
          <Button type="default"
                  stylingMode="contained"
                  useSubmitBehavior
                  width={200}
                  onClick={onModalErrorOnClickButtonYesActRemoveMh3}
          >
            <LoadIndicator className="indicator" visible={loading} />
            <span>{formatMessage('textButton').yes}</span>
          </Button>
        </div>
      </PopupErrorMVP>
      {/* Отмена переработки */}
      <PopupMVP
        visible={modalData.visibleNotProcessing}
        onHiding={modalOnHiding}
        title={formatMessage('textModal').cancellationOfProcessing}
      >
        <div className="formData">
          <p>
            {`№ : ${dataSource.listNotProcessing !== ''
              ? trim(trim(dataSource.listNotProcessing, ' '), ';') : ''}`}
          </p>
          <div className="formButton">
            <Button
              text={formatMessage('textButton').no}
              type="default"
              stylingMode="text"
              onClick={modalOnHiding}
            />
            <Button
              type="default"
              stylingMode="contained"
              useSubmitBehavior
              width={200}
              onClick={sendNotProcessing}
            >
              <LoadIndicator className="indicator" visible={loading} />
              <span>{formatMessage('textButton').yesCancel}</span>
            </Button>
          </div>
        </div>
      </PopupMVP>
      <div />
    </>
  );
};
export default React.memo(Shipment);
